module.exports = __webpack_public_path__ + "static/media/data.d05d655a.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/pic/data.PNG
// module id = 563
// module chunks = 0